export default {
  getAgreements: state => {
    return state.user;
  },
  getError: state => {
    return state.error;
  },
};
